class HomePrime extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup()
        if (window.innerWidth < 768) {
            this.setupMobile();
        }
    }
    setup() {
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this, start: 'top top+=70%' },
            tweenArr: [
                new RevealText({ el: this.querySelector(".home-prime-label .txt"), color: "rgba(29, 29, 29, 0.80)", isFast: true }),
                new RevealTextReset({ el: this.querySelector(".home-prime-title .txt"), color: "black" }),
                new FadeSplitText({ el: this.querySelector(".home-prime-desc .txt") }),
                new FadeIn({ el: this.querySelector(`.home-prime-btn-${window.innerWidth > 991 ? 'dk' : 'mb'}`) }),
                new FadeSplitText({ el: this.querySelector(`.home-prime-sub-${window.innerWidth > 991 ? 'dk' : 'mb'} .txt`) }),
            ]
        })

        if (!getScreenType().isMobile) {
            gsap.set('.home-prime-list-item', { autoAlpha: 0 });
            ScrollTrigger.batch('.home-prime-list-item', {
                start: `top 80%`,
                batchMax: 2,
                once: true,
                onEnter: batch => {
                    batch.forEach((el, index) => {
                        gsap.set(el, { autoAlpha: 1 });
                        new MasterTimeline({
                            triggerInit: this,
                            timeline: gsap.timeline({ delay: index * .15 }),
                            tweenArr: [
                                new FadeIn({ el, clearProps: 'transform' }),
                                new ScaleInset({ el: el.querySelector(".home-prime-list-item-img") }),
                                new RevealText({ el: el.querySelector('.home-prime-list-item-title .txt'), color: "black" })
                            ],
                            stagger: .2
                        })
                    });
                }
            })
        }
    }
    setupMobile() {
        this.querySelector('.home-prime-list').classList.add('swiper');
        this.querySelector('.home-prime-list-inner').classList.add('swiper-wrapper');
        this.querySelectorAll('.home-prime-list-item').forEach((item) => item.classList.add('swiper-slide'));
        const swiperHomePrime = new Swiper(this.querySelector('.home-prime-list'), {
            modules: [Pagination],
            slidesPerView: 1,
            spaceBetween: parseRem(16),
            speed: 600,
            watchSlidesProgress: true,
            pagination: {
                el: this.querySelector('.home-prime-pagi'),
                bulletClass: 'home-prime-pagi-item',
                bulletActiveClass: 'is-active',
                clickable: true,
            }
        });
    }
}
customElements.define("home-prime", HomePrime);